<template>
  <div>
    <HeroSecondary v-bind="hero"/>
    <ul class="ViewStories__stories">
      <li
        v-for="story in stories"
        :key="story.title"
        class="ViewStories__story"
      >
        <ViewStoriesStory v-bind="story" />
      </li>
    </ul>
  </div>
</template>

<script>
  import Story from '@/api/stories';
  import Option from '@/api/options';

  import HeroSecondary from './HeroSecondary';
  import ViewStoriesStory from './ViewStoriesStory';

  export default {
    components: {
      HeroSecondary,
      ViewStoriesStory,
    },
    data() {
      return {
        hero: undefined,
        stories: undefined,
      };
    },
    created() {
      this.$store.commit('setViewName', 'Stories');

      this.fetchOptions();
      this.fetchStories();
    },
    methods: {
      cleanStory({
        title: { rendered: title },
        content: { rendered: content },
        acf: { image, products },
      }) {
        return {
          title,
          image,
          content,
          products,
        };
      },
      async fetchOptions() {
        this.hero = (await Option.find('stories-settings')).acf.hero;
      },
      async fetchStories() {
        this.stories = (await Story.all()).map(this.cleanStory);
      },
    },
  };
</script>

<style
  scoped
  lang="scss"
>
  .ViewStories__stories {
    padding: spacing(base-gamma);
    max-width: $max-width;
    margin-right: auto;
    margin-left: auto;

    @include breakpoint(phablet) {
      padding-top: spacing(base-eta);
      padding-bottom: spacing(base-eta);
    }
  }

  .ViewStories__story {
    & + & {
      margin-top: spacing(base-delta);

      @include breakpoint(phablet) {
        margin-top: spacing(base-zeta);
      }
    }
  }
</style>
